module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_16_9_w_1976.c61e414.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_16_9_w_1976.jpg
// module id = R6vQ
// module chunks = 0